<template>
  <div class="card">
    <div class="card-header">
      {{ $t('transfer_histories.index') }}
    </div>
    <div class="card-body" style="padding: 0;">
      <table class="table table-striped table-hover">
        <thead>
          <th>{{ $t('users.user_fullname') }}</th>
          <th>{{ $t('transfer_histories.start_date') }}</th>
          <th>{{ $t('transfer_histories.end_date') }}</th>
        </thead>
        <tbody>
          <tr v-for="(transfer, index) in transfers">
            <td>{{transfer.user.lastname}} {{transfer.user.firstname}}</td>
            <td>{{transfer.start_date | datetimeFormat}}</td>
            <td>{{transfer.end_date | datetimeFormat}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'debtId',
  ],
  data() {
    return {
      transfers: [],
      isProcessing: false,
    };
  },
  mounted() {
    this.fetchTransfers();
  },
  methods: {
    fetchTransfers() {
      this.isProcessing = true;
      axios.get(`/debtor/${this.$route.params.id}/transfers`)
        .then((res) => {
            this.transfers = res.data.transfers;
        })
        .finally(() => {
          this.isProcessing = false;
        });
    }
  },
  watch: {
    '$route'() {
      this.fetchTransfers();
    },
  },
};
</script>
